export default __webpack_public_path__ + "static/media/create_strategy_modal.bc702e64.png";